import { render, staticRenderFns } from "./Street.vue?vue&type=template&id=1ba7ff36&"
import script from "./Street.vue?vue&type=script&lang=ts&"
export * from "./Street.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports